import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const WaterPurification = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Water purification"
    videos={[
      "https://www.youtube.com/embed/a273pRy8bHk",
      "https://www.youtube.com/embed/ctlHNf1s6RM",
      "https://www.youtube.com/embed/8bzYETuc3bY"
    ]}
    takeaways={[
      { text: "Learn all the water purification methods along with respective diagram." },
      { text: "Indirect questions might be asked." }
    ]}
    questions={[
      "Using a neat diagram explain in detail a water softening method which can chemically soften both acid and alkaline water. List its pros and cons.",
      "Describe a suitable method for converting seawater into potable water and discuss its advantages.",
      "Purification of water is very challenging now-a-days due to the presence of various chemical impurities. Explain the Ion-exchange process of demineralization of water by depicting chemical equations."
    ]}
    exampleVideos={[]}
  />
);
}

export default WaterPurification;
